import { combineReducers } from 'redux';

import events from './events_reducer';
import pastEvents from './past_events_reducer';
import features from './feature_reducer';
import searchTerm from './search_reducer';
import regions from './regions_reducer';
import regionTerm from './region_filter_reducer';
import categories from './categories-reducer';
import categoryTerm from './category_filter_reducer';
import eventContactBoxes from './reducer-event-contact-boxes';

export default combineReducers( {
	                                events,
									pastEvents,
	                                features,
	                                searchTerm,
	                                regions,
	                                regionTerm,
	                                categories,
	                                categoryTerm,
	                                eventContactBoxes
                                } );
